module.exports = __webpack_public_path__ + "img/icon_man.b5eb6d27.png";